import { z } from 'zod';
import { idSchema } from './content-primitives.ts';
import { versionedPatchFields } from './json-patch.ts';
import { stringPatchTool } from './string-patch.ts';

const guidance =
  'Supply the versionId you read as expectedVersionId and an RFC 6902 JSON Patch array. The tool first tests that version, then applies your operations atomically. A stale version returns 409. Saves a draft without publishing. Read-only fields may be tested but not changed.';
export const patchToolDefinitions = {
  patch_string_field: stringPatchTool,
  patch_page: {
    name: 'patch_page',
    title: 'Patch page or post',
    description: `Patch a page or post. ${guidance}`,
    schema: z.strictObject({ pageId: idSchema, ...versionedPatchFields }),
    readOnly: false,
    idempotent: false,
  },
  patch_site_settings: {
    name: 'patch_site_settings',
    title: 'Patch site settings',
    description: `Patch site settings. ${guidance}`,
    schema: z.strictObject({ siteId: idSchema, ...versionedPatchFields }),
    readOnly: false,
    idempotent: false,
  },
  patch_form: {
    name: 'patch_form',
    title: 'Patch form',
    description: `Patch a form. Submission actions are separate resources. ${guidance}`,
    schema: z.strictObject({ formId: idSchema, ...versionedPatchFields }),
    readOnly: false,
    idempotent: false,
  },
  patch_form_submission_action: {
    name: 'patch_form_submission_action',
    title: 'Patch form submission action',
    description: `Patch a form submission action. Its config.kind cannot change. ${guidance}`,
    schema: z.strictObject({ id: idSchema, ...versionedPatchFields }),
    readOnly: false,
    idempotent: false,
  },
  patch_asset: {
    name: 'patch_asset',
    title: 'Patch asset metadata',
    description: `Patch asset alt text or archived status. File properties are read-only. ${guidance}`,
    schema: z.strictObject({ assetId: idSchema, ...versionedPatchFields }),
    readOnly: false,
    idempotent: false,
  },
} as const;
